import * as Yup from 'yup';
import messages from './loginForm.messages';
import { LOGIN_FIELDS as FIELDS } from '../../../modules/auth/auth.constants';

export const defaultValues = {
  [FIELDS.email]: '',
  [FIELDS.password]: '',
};

export const LoginSchema = Yup.object().shape({
  [FIELDS.email]: Yup.string()
    .email(messages.incorrectEmailFormat)
    .required(messages.fieldRequired),
  [FIELDS.password]: Yup.string().required(messages.fieldRequired),
});
